angular.module('zc.zenclerkS')
  .component('zcsNotificationTimezone', {
    templateUrl: '/templates/zenclerk_s/directives/notification/timezone.html',
    bindings: {
      project: '=',
      static: '=',
      status: '@'
    },
    controllerAs: 'vm',
    controller: ZcsNotificationTimezoneController,
  });

function ZcsNotificationTimezoneController() {
  const vm = this;
  if(!vm.status) vm.status = 'warning';
  vm.isTimezoneDiff = moment().tz(vm.project.region).format('Z') !== moment().tz(moment.tz.guess(true)).format('Z');
  vm.showAlert = true;

  vm.hideAlert = hideAlert;
  function hideAlert() {
    vm.showAlert = false;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/notification/timezone.js